<template>
    <div class="main-app">
        <!-- <div style="margin-top: 40px;width: 80%;height: 80%;"> -->
        <div >
            <el-form style="margin-top: 20px;margin-left: 10px;margin-right: 10px;" ref="form" :model="form" label-width="auto"  :rules="rules">
                <el-form-item label="Your Name" required style="width: 100%;" >
                    <div style="width: 100%;display: flex;">
                        <div style="width: 30%;">
                            <el-form-item prop="sex">
                                <el-select v-model="form.sex" placeholder="gender" prop="gender" >
                                    <el-option label="Mr" value="男"></el-option>
                                    <el-option label="Ms" value="女"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div style="margin-left: 10px;width: 70%;">
                            <el-form-item prop="userName">
                                <el-input v-model="form.userName"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item  label="E-mail address" prop="email">
                    <el-input type="email" v-model="form.email" placeholder="E-mail" prop="email"></el-input>
                </el-form-item>
                <el-form-item  label="Purchase channel" prop="purchaseChannel">
                    <el-select v-model="form.purchaseChannel" placeholder="Select Purchase channel" prop="purchaseChannel" style="width: 100%;">
                        <el-option label="Aliexpress" value="Aliexpress"></el-option>
                        <el-option label="Amazon" value="Amazon"></el-option>
                        <el-option label="Ebay" value="Ebay"></el-option>
                        <el-option label="Other" value="Other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="Model Number" prop="modelNumber">
                    <el-input v-model="form.modelNumber" placeholder="Find it on the back of the machine" prop="modelNumber"></el-input>
                </el-form-item>

                <div style="margin-left: 20px;margin-right: 20px;">
                    <div>We would like to see your reviews and picture feedback on Amazon. To improve the quality of our services and products. Would you like to receive emails and participate in our brand’s activities, which include exclusive offers and free experiences with new products. </div>
                </div>
                <div style="margin-left: 20px;margin-right: 20px;margin-top: 5px;">
                    <el-radio v-model="form.will" label="0">Yes</el-radio>
                    <el-radio v-model="form.will" label="1">No</el-radio>
                </div>
                <br/><br/>
            <div style="margin-left: 10px;margin-right: 10px;">
                Note: We are committed to protecting the privacy of our customers, the above information is only for the after-sales service of Shenzhen ZEUS Information Technology Co.,LTD.
            </div>
            <br/>
            </el-form>
            <div style="margin-left: 10px;margin-right: 10px;">
                <el-button type="primary" @click="onSubmit('form')">submit</el-button>
            </div>
            

        </div>
    </div>
  </template>
  
  <script>

import { mapMutations } from "vuex";
import LStore from "store";
import API from "@/api/opinion.js";
import API2 from "@/api";

  export default {
    data() {
      return {
        form: {
          userName: '',
          sex: '男',
          email: '',
          purchaseChannel: '',
          will:'0',
          modelNumber: ''
        },
        // fileList: [],
        rules: {
            userName: [
            { required: true, message: 'Please enter name', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          sex: [
            { required: true, message: 'Please enter a gender', trigger: 'blur' }
          ],
          email: [
            { required: true,  trigger: 'blur' , validator: this.checkEmail }
          ],
          modelNumber: [
            { required: true, trigger: 'blur' , message: 'Please enter Model Number'}
          ],
          purchaseChannel: [
            { required: true, trigger: 'blur' , message: 'Please select Purchase Channel'}
          ],
          
        }
      };
    },
    computed: {
     
    },
    created() {
        this.productCat();
    },
    methods: {
        ...mapMutations(["PRODUCT_DATA"]),
        productCat(params) {
            API2.productCat(params).then(res => {
            if (/^(1)$/.test(res.code)) {
            this.PRODUCT_DATA(res.data);
            LStore.set("productData", res.data);
            } else {
            this.$message.error(res.msg);
            }
        });
        },
        checkEmail (rule, value, callback) {
            const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            if (!value||value=='') {
                return callback(new Error('The email address cannot be empty'))
            }
            setTimeout(() => {
                if (mailReg.test(value)) {
                    callback()
                } else {
                    callback(new Error('Please enter the correct email address'))
                }
            }, 100)
        },

        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // console.log(this.form)
                    API.feedback(this.form).then(res => {
                        if(res.code == 1){
                            this.$message.success('submission success');
                            this.$router.push({ path: "/" });
                        }else{
                            this.$message.error(res.msg);
                        } 
                    });
                    console.log(this.form);
                    this.$refs.upload.submit();
                } else {
                    return false;
                }
            })
        }
    }
  };
  </script>
  
  <style >

.el-form-item__label-wrap {
  margin-left: 0px !important;
}
  </style>